import React, { Fragment } from "react";
import { formatMonthYear, DateCalc } from "../utils/dateFormat.utils";
import { trackEvent } from "../utils/tracking.utils";

const Experience = (props) => {
  const data = props.data;
  return (
    <Fragment>
      <section
        className="resume-section p-3 p-lg-5 d-flex flex-column"
        id="experience"
      >
        <div className="my-auto">
          <h2>Experience</h2>
          {data.map((exp) => {
            return (
              <div
                className="resume-item d-flex flex-column flex-md-row mt-5"
                key={exp.id}
              >
                <div className="resume-content me-auto">
                  <h3 className="mb-0">{exp.role}</h3>
                  <div className="subheading normal-text">
                    {exp.url ? (
                      <a
                        className="remove-underline"
                        href={exp.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => trackEvent("company_click", "experience", exp.name)}
                      >
                        {exp.name}
                      </a>
                    ) : (
                      <a
                        className="remove-underline"
                        href="#/"
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                        rel="noopener noreferrer"
                      >
                        {exp.name}
                      </a>
                    )}
                  </div>
                  <div className="d-md-none mb-3">
                    <span className="text-primary">
                      {formatMonthYear(exp.start_date)} -{" "}
                      {exp.is_present ? "Present" : formatMonthYear(exp.end_date)}
                    </span>
                    <div className="text-muted exp_date">{`${DateCalc(
                      exp.start_date,
                      exp.is_present ? new Date() : exp.end_date,
                    )}`}</div>
                  </div>
                  <ul className="mt-2">
                    {exp.line_1.map((point, i) => (
                      <li key={i} className="mb-2" dangerouslySetInnerHTML={{ __html: point }} />
                    ))}
                  </ul>
                  {exp.line_2 && <p>{exp.line_2}</p>}
                  <div>
                    <ul className="tags">
                      {exp.tags.map((tag) => {
                        return <li className="tag">{tag}</li>;
                      })}
                    </ul>
                  </div>
                </div>
                <div className="resume-date text-md-end d-none d-md-block">
                  <span className="text-primary">
                    {formatMonthYear(exp.start_date)} -{" "}
                    {exp.is_present ? "Present" : formatMonthYear(exp.end_date)}
                  </span>
                  <div className="text-muted exp_date">{`${DateCalc(
                    exp.start_date,
                    exp.is_present ? new Date() : exp.end_date,
                  )}`}</div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </Fragment>
  );
};

export default Experience;
